import * as ActionTypes from '../Favourites';

export function toggleFavouriteLeague(data) {
    return {type: ActionTypes.TOGGLE_FAVOURITE_LEAGUE, data, section: 'live'};
}

export function toggleFavouriteMatch(data) {
    return {type: ActionTypes.TOGGLE_FAVOURITE_MATCH, data, section: 'live'};
}

export function toggleFavouriteSport(data) {
    return {type: ActionTypes.TOGGLE_FAVOURITE_SPORT, data, section: 'live'};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Favourites.js